/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppContainerPicker from 'shared/ui/components/form-components/pickers/AppContainerPicker.vue';
import WizardStep from 'shared/ui/components/WizardStep.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import InteractivityOptions from 'shared/ui/components/live-sessions/settings/InteractivityOptions.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    name: 'General',

    components: {
        AppContainerPicker,
        BaseInput,
        InteractivityOptions,
        Toggler
    },

    extends: WizardStep,

    watch: {
        'form.interprefyEnabled': function(next, prev) {
            if (prev !== null && next === false) {
                this.$nextTick(() => this.validate(true));
            }
        }
    },

    methods: {
        /**
         * react to change to interactivity options in child component
         *
         * @param {object} payload
         * @param {string} payload.field object field to change
         * @param {any} payload.value new value to store
         */
        change({ field, value }) {
            this.form = {
                ...this.form,
                [field]: value,
            };
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    {
      ref: "form",
      staticClass: "webinar-form",
      attrs: { tag: "form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("validation-provider", {
        attrs: {
          rules: "required",
          slim: true,
          name: _vm.$t("field_name.name"),
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("base-input", {
                  attrs: {
                    label: _vm.$t("wizards.create_webinar_template.form.name"),
                    type: "text",
                    name: "name",
                    focused: _vm.focus == "name",
                    errors: errors,
                  },
                  model: {
                    value: _vm.form.name,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "name", $$v)
                    },
                    expression: "form.name",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("validation-provider", {
        attrs: { rules: "required", slim: true, name: "branded_app" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("app-container-picker", {
                  ref: "branded_app",
                  attrs: {
                    label: _vm.$t("webinars.form.branded_app"),
                    placeholder: _vm.$t(
                      "webinars.form.branded_app_placeholder"
                    ),
                    name: "branded_app",
                    errors: errors,
                    "open-direction": "below",
                  },
                  model: {
                    value: _vm.form.branded_app,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "branded_app", $$v)
                    },
                    expression: "form.branded_app",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("interactivity-options", {
        staticClass: "form-group",
        attrs: {
          "show-polls-option": "show-polls-option",
          "show-claps-option": "show-claps-option",
          "show-qna-moderation-option": "show-qna-moderation-option",
          "show-interprefy-option": "show-interprefy-option",
        },
        on: { change: _vm.change },
        model: {
          value: _vm.form,
          callback: function ($$v) {
            _vm.form = $$v
          },
          expression: "form",
        },
      }),
      _c("toggler", {
        attrs: {
          label: _vm.$t("webinars.automatedEmails.title"),
          name: "automatedEmails",
          "on-label": "webinars.automatedEmails.label",
          "off-label": "webinars.automatedEmails.label",
          hint: _vm.$t("webinars.automatedEmails.hint"),
          hintAfterLabel: true,
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return [
                !_vm.form.automatedEmails
                  ? _c("div", { staticClass: "alert alert-warning" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.$t("webinars.automatedEmails.warning"))
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "webinars.automatedEmails.warning_description"
                            )
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.form.automatedEmails,
          callback: function ($$v) {
            _vm.$set(_vm.form, "automatedEmails", $$v)
          },
          expression: "form.automatedEmails",
        },
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/wizards/create-webinar-template/General.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__